import Riders from '@/views/riders/Riders.vue'
import RiderDetail from '@/views/riders/RiderDetail'

export default [
  {
    path: 'jinetes',
    name: 'riders.list',
    component: Riders
  },
  {
    path: 'jinetes/:id/ficha',
    name: 'riders.detail',
    component: RiderDetail
  }
]
